export default __webpack_public_path__ + "static/media/property_152.6a775d4b.png";